import { BaseContainerModel } from "../base-container.model";
import { bl_mkp_mst_item_image_hdr_RowInterface } from "../../dbschema/bl_mkp_mst_item_image_hdr.model";

export class MkpItemImageHdrContainerModel extends BaseContainerModel {
  bl_mkp_mst_item_image_hdr: bl_mkp_mst_item_image_hdr_RowInterface;
} 
